import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import DataDrivenExcellence from "./sections/DataDrivenExcellence";
import TheInfinixApproach from "./sections/TheInfinixApproach";
import CoreCapabilities from "./sections/CoreCapabilities";
import StrategicAdvantages from "./sections/StrategicAdvantages";
import ReadyToTransform from "./sections/ReadyToTransform";
import CorporateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="!opacity-[1] !bg-[rgba(0,0,0,1)]">
      <MainNavigation />
      <DataDrivenExcellence />
      <TheInfinixApproach />
      <CoreCapabilities />
      <StrategicAdvantages />
      <ReadyToTransform />
      <CorporateFooter />
    </div>;
}